import React, { useState, useEffect } from "react";
import SummaryApi from "./common/index";

const PopupForm = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(true);
    }, 2000); 
    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target); // Use FormData to gather inputs

    try {
      const response = await fetch(SummaryApi.popupForm.url, {
        method: "POST",
        body: formData, // Directly send FormData
      });

      if (response.ok) {
        alert("Form submitted successfully!");
        // console.log("Form Data:", Object.fromEntries(formData)); 
      } else {
        alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      alert("An error occurred: " + error.message);
    }

    setIsOpen(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 mt-[15%] md:hidden w-[90%] mx-auto " id="#popup">
      <div className="bg-white p-6 rounded-lg shadow-lg flex flex-col md:flex-row relative z-60 max-w-[720px] w-full">
        <div className="">
          <button
            className="absolute top-2 right-2 text-gray-500 hover:text-gray-800"
            onClick={handleClose}
          >
            &times;
          </button>
          <h2 className="text-3xl mb-10 text-[#03833e] font-bold text-center">
            Start your journey with Siddhi Ganapathi Developers.
          </h2>
          <p className="mb-4 text-gray-500 text-center">
            Limited plots available—secure your investment now.
          </p>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter Name"
              required
              className="border border-gray-300 rounded p-2 mb-4 w-full"
            />
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter Email"
              required
              className="border border-gray-300 rounded p-2 mb-4 w-full"
            />
            <input
              type="tel"
              id="mobileNumber"
              name="mobileNumber"
              placeholder="Enter Mobile Number"
              required
              className="border border-gray-300 rounded p-2 mb-4 w-full"
            />
            <input
              type="text"
              id="city"
              name="city"
              placeholder="Enter City"
              required
              className="border border-gray-300 rounded p-2 mb-4 w-full"
            />
            <textarea
              id="message"
              name="message"
              placeholder="Enter Message"
              required
              className="border border-gray-300 rounded p-2 mb-4 w-full"
            />
            <input
              type="submit"
              value="Send"
              className="bg-[#03833e] text-white rounded p-2 hover:bg-[#03833e]/80 w-full"
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default PopupForm;
